import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'osc-text-table-header',
    templateUrl: './text-table-header.component.html',
    styleUrls: ['./text-table-header.component.scss'],
    imports: [NgClass],
})
export class TextTableHeaderComponent {
    @Input() public name?: string;
    @Input() public ellipsis?: boolean = false;
}
